import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../../app.constants';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { NoteSearchModel } from '../../models/note-related/NoteSearchModel';
import { NoteCreateModel } from '../../models/note-related/NoteCreateModel';
import { NoteUpdateModel } from '../../models/note-related/NoteUpdateModel';

@Injectable()
export class NoteWidgetService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/NoteWidget/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (noteId: string): Observable<NoteSearchModel> => {
        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        params.set('noteId', noteId);

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public Update = (noteId: string, noteContent: string): Observable<Response> => {
        this.setHeaders();
        let updatedNote: NoteUpdateModel = {
            NoteId: noteId,
            NoteContent: noteContent,
            UserId: this.uData.sub
        }

        let options = new RequestOptions({ headers: this.headers });
        return this._http.put(this.actionUrl, JSON.stringify(updatedNote), options);
    }

    public Create = (newNote: NoteCreateModel): Observable<Response> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, JSON.stringify(newNote), options);
    }

    public Delete = (noteId: string): Observable<Response> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.delete(this.actionUrl + noteId, options);
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/note-widget-container/note-widget/note-widget.service.ts